export const getMakerName = (vehicle) => {
  var maker = vehicle.maker
  if (maker === 'Otro' && vehicle.custom_maker) { 
    maker = vehicle.custom_maker
  }
  return maker
}

export const getBrandName = (vehicle) => {
  var brand = vehicle.brand
  if (brand === 'Otro' && vehicle.custom_brand) { 
    brand = vehicle.custom_brand
  }
  return brand
}

export const getModelName = (vehicle) => {
  var model = vehicle.model
  if (model === 'Otro' && vehicle.custom_model) { 
    model = vehicle.custom_model
  }
  return model
}



// WEBPACK FOOTER //
// ./src/utils/vehicle.js